import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectResults } from 'shared/selectors/results';
import { selectBreadcrumbs } from 'shared/selectors/selectBreadcrumbs';

import { trackBreadcrumbClick } from './tracking';
import { HeaderDefault } from '../../serp/components/header/default/index';

export const HeaderDefaultContainer: React.FC = () => {
  const { seo } = useSelector(selectResults);
  const breadcrumbs = useSelector(selectBreadcrumbs);

  const onBreadcrumbClick = (url: string) => {
    trackBreadcrumbClick(url);
  };

  return <HeaderDefault seo={seo} breadcrumbs={breadcrumbs} onBreadcrumbClick={onBreadcrumbClick} />;
};
